import { createContext } from 'react';

export function createEmptyContext<T>() {
    return createContext(undefined as unknown as T);
}
